import { useEffect } from "react";

import { useAvailableManageRolesAdditionalColumns } from "./use_available_manage_roles_additional_columns";
import { useManageRolesStoreActions } from "./use_manage_roles_store";

export const useSyncManageRolesAvailableColumns = () => {
  const availableColumns = useAvailableManageRolesAdditionalColumns();
  const { setAvailableColumns } = useManageRolesStoreActions();

  useEffect(() => {
    setAvailableColumns(availableColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableColumns]);
};
